import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_08283616 from 'nuxt_plugin_plugin_08283616' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_4465b420 from 'nuxt_plugin_sentryserver_4465b420' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_7813b468 from 'nuxt_plugin_sentryclient_7813b468' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_image_19114f27 from 'nuxt_plugin_image_19114f27' // Source: ./image.js (mode: 'all')
import nuxt_plugin_dayjsplugin_3974059e from 'nuxt_plugin_dayjsplugin_3974059e' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_index_02de96e2 from 'nuxt_plugin_index_02de96e2' // Source: ./firebase/index.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_d55bcc58 from 'nuxt_plugin_cookieuniversalnuxt_d55bcc58' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginutils_1e7d398f from 'nuxt_plugin_pluginutils_1e7d398f' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2a159f1a from 'nuxt_plugin_pluginrouting_2a159f1a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_21e99ad6 from 'nuxt_plugin_pluginmain_21e99ad6' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_vuesocialsharingplugin_910681b6 from 'nuxt_plugin_vuesocialsharingplugin_910681b6' // Source: ./vue-social-sharing-plugin.js (mode: 'all')
import nuxt_plugin_templatesplugind9d213c6_d28c9278 from 'nuxt_plugin_templatesplugind9d213c6_d28c9278' // Source: ./templates.plugin.d9d213c6.js (mode: 'client')
import nuxt_plugin_gtm_2a91b402 from 'nuxt_plugin_gtm_2a91b402' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_deviceplugin_001a0492 from 'nuxt_plugin_deviceplugin_001a0492' // Source: ./device.plugin.js (mode: 'all')
import nuxt_plugin_axios_2e0a522c from 'nuxt_plugin_axios_2e0a522c' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginserver_359dfc90 from 'nuxt_plugin_pluginserver_359dfc90' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_6036e9f0 from 'nuxt_plugin_pluginclient_6036e9f0' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_googleanalytics_14fe327a from 'nuxt_plugin_googleanalytics_14fe327a' // Source: ./google-analytics.js (mode: 'client')
import nuxt_plugin_logger_057b83b1 from 'nuxt_plugin_logger_057b83b1' // Source: ../plugins/logger.js (mode: 'all')
import nuxt_plugin_antdui_420bdf2e from 'nuxt_plugin_antdui_420bdf2e' // Source: ../plugins/antd-ui.js (mode: 'client')
import nuxt_plugin_agorartc_ce18263e from 'nuxt_plugin_agorartc_ce18263e' // Source: ../plugins/agora-rtc.js (mode: 'client')
import nuxt_plugin_centrifuge_3552af7c from 'nuxt_plugin_centrifuge_3552af7c' // Source: ../plugins/centrifuge (mode: 'client')
import nuxt_plugin_gtag_6a810249 from 'nuxt_plugin_gtag_6a810249' // Source: ../plugins/gtag (mode: 'client')
import nuxt_plugin_persistedState_1da1c1a3 from 'nuxt_plugin_persistedState_1da1c1a3' // Source: ../plugins/persistedState.js (mode: 'client')
import nuxt_plugin_vuesocialsharing_216967be from 'nuxt_plugin_vuesocialsharing_216967be' // Source: ../plugins/vue-social-sharing.js (mode: 'client')
import nuxt_plugin_vueplyr_a4e20576 from 'nuxt_plugin_vueplyr_a4e20576' // Source: ../plugins/vue-plyr.js (mode: 'client')
import nuxt_plugin_vueinfiniteloading_5f280597 from 'nuxt_plugin_vueinfiniteloading_5f280597' // Source: ../plugins/vue-infinite-loading.js (mode: 'client')
import nuxt_plugin_vuecarousel_e4202ecc from 'nuxt_plugin_vuecarousel_e4202ecc' // Source: ../plugins/vue-carousel.js (mode: 'client')
import nuxt_plugin_vuedraggable_11e72f9a from 'nuxt_plugin_vuedraggable_11e72f9a' // Source: ../plugins/vuedraggable.js (mode: 'client')
import nuxt_plugin_virtualscroll_5c1c99dc from 'nuxt_plugin_virtualscroll_5c1c99dc' // Source: ../plugins/virtual-scroll.js (mode: 'client')
import nuxt_plugin_stickysidebar_33c6998c from 'nuxt_plugin_stickysidebar_33c6998c' // Source: ../plugins/stickysidebar.js (mode: 'client')
import nuxt_plugin_dayjs_66ce5f68 from 'nuxt_plugin_dayjs_66ce5f68' // Source: ../plugins/dayjs.js (mode: 'server')
import nuxt_plugin_localecountry_82511984 from 'nuxt_plugin_localecountry_82511984' // Source: ../plugins/locale-country.js (mode: 'client')
import nuxt_plugin_chart_48b5b2cf from 'nuxt_plugin_chart_48b5b2cf' // Source: ../plugins/chart.js (mode: 'client')
import nuxt_plugin_auth_271f3cf8 from 'nuxt_plugin_auth_271f3cf8' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'client')
import nuxt_plugin_ganktoken_a17bb2c4 from 'nuxt_plugin_ganktoken_a17bb2c4' // Source: ../plugins/gank-token.js (mode: 'all')
import nuxt_plugin_userdata_6d35befe from 'nuxt_plugin_userdata_6d35befe' // Source: ../plugins/user-data.js (mode: 'client')
import nuxt_plugin_freshchat_1c4a1927 from 'nuxt_plugin_freshchat_1c4a1927' // Source: ../plugins/freshchat.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Gank - Earn More From Your Content","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover"},{"name":"apple-itunes-app","content":"app-id=1539615114"},{"hid":"fb:app_id","property":"fb:app_id","content":"300582610935557"},{"hid":"og:type","property":"og:type","content":"website"},{"hid":"og:site_name","property":"og:site_name","content":"ganknow.com"},{"hid":"description","name":"description","content":"Gank is a content membership platform that helps content creators accept donations, manage memberships and sell merch, for free."},{"name":"google-site-verification","content":"xu87wXV8m2Z4tmwpb40BRAttz6inYF0vK4CyEIULSsg"},{}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?v=2"},{"rel":"apple-touch-icon","type":"image\u002Fpng","href":"\u002Fgank-icon.png"}],"script":[{"hid":"google_platform","src":"https:\u002F\u002Fapis.google.com\u002Fjs\u002Fplatform.js","defer":true},{"hid":"stripe_js","src":"https:\u002F\u002Fjs.stripe.com\u002Fv3","defer":true},{"src":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002Fpwacompat@2.0.6\u002Fpwacompat.min.js","integrity":"sha384-GOaSLecPIMCJksN83HLuYf9FToOiQ2Df0+0ntv7ey8zjUHESXhthwvq9hXAZTifA","crossorigin":"anonymous","defer":true},{"type":"text\u002Fjavascript","src":"https:\u002F\u002Fcl.qualaroo.com\u002Fki.js\u002F86274\u002FjXQ.js","async":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-NMK8J4M')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"}],"manifest":{"name":"Gank","title":"Gank","og:title":"Gank","description":"Gank is a content membership platform that helps content creators accept donations, manage memberships and sell merch, for free.","og:description":"Gank is a content membership platform that helps content creators accept donations, manage memberships and sell merch, for free.","theme_color":"#FFFFFF","background_color":"#FFFFFF","start_url":"https:\u002F\u002Fganknow.com\u002F","short_name":"Gank","icons":[{"src":"\u002Fgank-logo-144x144.png","size":"144x144","type":"image\u002Fpng"},{"src":"\u002Fgank-logo-128x128.png","size":"128x128","type":"image\u002Fpng"},{"src":"\u002Fgank-logo-152x152.png","size":"152x152","type":"image\u002Fpng"},{"src":"\u002Fgank-logo-180x180.png","size":"180x180","type":"image\u002Fpng"},{"src":"\u002Fgank-logo-192x192.png","size":"192x192","type":"image\u002Fpng"},{"src":"\u002Fgank-logo-256x256.png","size":"256x256","type":"image\u002Fpng"}]},"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-NMK8J4M&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_08283616 === 'function') {
    await nuxt_plugin_plugin_08283616(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_4465b420 === 'function') {
    await nuxt_plugin_sentryserver_4465b420(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_7813b468 === 'function') {
    await nuxt_plugin_sentryclient_7813b468(app.context, inject)
  }

  if (typeof nuxt_plugin_image_19114f27 === 'function') {
    await nuxt_plugin_image_19114f27(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_3974059e === 'function') {
    await nuxt_plugin_dayjsplugin_3974059e(app.context, inject)
  }

  if (typeof nuxt_plugin_index_02de96e2 === 'function') {
    await nuxt_plugin_index_02de96e2(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_d55bcc58 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_d55bcc58(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_1e7d398f === 'function') {
    await nuxt_plugin_pluginutils_1e7d398f(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2a159f1a === 'function') {
    await nuxt_plugin_pluginrouting_2a159f1a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_21e99ad6 === 'function') {
    await nuxt_plugin_pluginmain_21e99ad6(app.context, inject)
  }

  if (typeof nuxt_plugin_vuesocialsharingplugin_910681b6 === 'function') {
    await nuxt_plugin_vuesocialsharingplugin_910681b6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugind9d213c6_d28c9278 === 'function') {
    await nuxt_plugin_templatesplugind9d213c6_d28c9278(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_2a91b402 === 'function') {
    await nuxt_plugin_gtm_2a91b402(app.context, inject)
  }

  if (typeof nuxt_plugin_deviceplugin_001a0492 === 'function') {
    await nuxt_plugin_deviceplugin_001a0492(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_2e0a522c === 'function') {
    await nuxt_plugin_axios_2e0a522c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_359dfc90 === 'function') {
    await nuxt_plugin_pluginserver_359dfc90(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_6036e9f0 === 'function') {
    await nuxt_plugin_pluginclient_6036e9f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googleanalytics_14fe327a === 'function') {
    await nuxt_plugin_googleanalytics_14fe327a(app.context, inject)
  }

  if (typeof nuxt_plugin_logger_057b83b1 === 'function') {
    await nuxt_plugin_logger_057b83b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_antdui_420bdf2e === 'function') {
    await nuxt_plugin_antdui_420bdf2e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_agorartc_ce18263e === 'function') {
    await nuxt_plugin_agorartc_ce18263e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_centrifuge_3552af7c === 'function') {
    await nuxt_plugin_centrifuge_3552af7c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtag_6a810249 === 'function') {
    await nuxt_plugin_gtag_6a810249(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_persistedState_1da1c1a3 === 'function') {
    await nuxt_plugin_persistedState_1da1c1a3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuesocialsharing_216967be === 'function') {
    await nuxt_plugin_vuesocialsharing_216967be(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueplyr_a4e20576 === 'function') {
    await nuxt_plugin_vueplyr_a4e20576(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueinfiniteloading_5f280597 === 'function') {
    await nuxt_plugin_vueinfiniteloading_5f280597(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuecarousel_e4202ecc === 'function') {
    await nuxt_plugin_vuecarousel_e4202ecc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuedraggable_11e72f9a === 'function') {
    await nuxt_plugin_vuedraggable_11e72f9a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_virtualscroll_5c1c99dc === 'function') {
    await nuxt_plugin_virtualscroll_5c1c99dc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_stickysidebar_33c6998c === 'function') {
    await nuxt_plugin_stickysidebar_33c6998c(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_dayjs_66ce5f68 === 'function') {
    await nuxt_plugin_dayjs_66ce5f68(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_localecountry_82511984 === 'function') {
    await nuxt_plugin_localecountry_82511984(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_chart_48b5b2cf === 'function') {
    await nuxt_plugin_chart_48b5b2cf(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_271f3cf8 === 'function') {
    await nuxt_plugin_auth_271f3cf8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_ganktoken_a17bb2c4 === 'function') {
    await nuxt_plugin_ganktoken_a17bb2c4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_userdata_6d35befe === 'function') {
    await nuxt_plugin_userdata_6d35befe(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_freshchat_1c4a1927 === 'function') {
    await nuxt_plugin_freshchat_1c4a1927(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
